export default __webpack_public_path__ + "static/media/GUM.bccabf99.svg";